module.exports = __webpack_public_path__ + "img/商丘市.e7bf15dd.png";